import React from 'react';
import { withTheme } from '../ThemeProvider';
import { StyledFooter } from './styles';

interface IModalFooter {
  buttonsList?: React.ReactNode[];
  theme?: any;
}

const FooterComponent: React.FC<IModalFooter> = ({ buttonsList }) => {
  return (
    <StyledFooter>
      {buttonsList?.map((item, index) => <React.Fragment key={index}>{item}</React.Fragment>)}
    </StyledFooter>
  );
};

export const Footer = withTheme(FooterComponent);
